import { IReducerResponse, ToastType } from "./type";

export const initialState: IReducerResponse = {
    track: {
        loading: false,
        error: false,
        data: {
            statusCode: 0,
            success: {
                cards: [],
            },
            data: { cards: [] },
        },
        lastUpdated: 0,
    },
    billSummary: {
        loading: false,
        error: false,
        errorInfo: {},
        data: {
            statusCode: 0,
            success: {
                cards: [],
            },
            data: { cards: [] },
        },
        lastUpdated: 0,
    },
    menu: {
        loading: false,
        error: false,
        data: {
            statusCode: 0,
            success: {
                cards: [],
            },
            data: { cards: [] },
        },
        lastUpdated: 0,
        initialData: [],
        filteredData: [],
        parentType: "",
        categoryId: "",
        preference: "",
        emptyItemCard: false,
        requestId: "",
    },
    cart: {
        loading: false,
        error: false,
        data: {
            statusCode: 0,
            success: {
                cards: [],
            },
            data: { cards: [] },
        },
        lastUpdated: 0,
        localCart: {
            restaurantId: "",
            tableId: "",
            cartItems: [],
        },
        isChildOrderExist: null,
    },
    curtain: {
        loading: false,
        error: false,
        data: {
            statusCode: 0,
            success: {
                cards: [],
            },
            data: { cards: [] },
        },
        lastUpdated: 0,
    },

    pin: {
        loading: false,
        error: false,
        data: {
            status: "",
        },
        lastUpdated: 0,
    },

    toast: {
        type: ToastType.INFO,
        message: "",
        show: false,
    },
    paymentFailure: {
        show: false,
        amount: "",
        paymentFailureCardData: {},
    },
    collections: {},
    crossSell: {
        entries: [],
        config: undefined,
        shownItemIds: [],
    },
    placeOrderFailure: {
        loading: false,
        error: false,
        isFullScreenError: false,
        data: {
            statusCode: 0,
            success: {
                cards: [],
            },
            data: { cards: [] },
        },
        lastUpdated: 0,
    },
};
